import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { customerApi } from '../../services/customerAuth'
import { useLanguage } from '../../context/LanguageContext'

export default function ReviewPage() {
  const { t } = useLanguage()
  const { token } = useParams()
  const [state, setState] = useState({ phase: 'loading', data: null, error: null })
  const [rating, setRating] = useState(0)
  const [text, setText] = useState('')
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    customerApi.get(`/review/${token}`)
      .then(({ data }) => {
        if (data.alreadySubmitted) {
          setRating(data.rating)
          setText(data.reviewText || '')
          setState({ phase: 'already', data })
        } else {
          setState({ phase: 'ready', data })
        }
      })
      .catch(err => setState({ phase: 'error', error: err.response?.data?.message || err.message }))
  }, [token])

  async function submit(e) {
    e.preventDefault()
    if (rating < 1) return
    setSubmitting(true)
    try {
      await customerApi.post(`/review/${token}`, { rating, reviewText: text || null })
      setState({ phase: 'thanks', data: state.data })
    } catch (err) {
      alert(err.response?.data?.message || t('sp_submit_failed', 'Submit failed'))
    } finally { setSubmitting(false) }
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', padding: '40px 16px', fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif" }}>
      <div style={{ maxWidth: 520, margin: '0 auto', background: '#fff', padding: 28, borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
        {state.phase === 'loading' && <div style={{ color: '#64748b', textAlign: 'center' }}>{t('sp_loading_short', 'Loading…')}</div>}
        {state.phase === 'error' && <div style={{ color: '#991b1b', textAlign: 'center' }}>{state.error}</div>}

        {state.phase === 'already' && (
          <>
            <h2 style={{ color: '#153230', margin: '0 0 8px' }}>{t('sp_review_already_received', 'Thanks — already received')}</h2>
            <p style={{ color: '#475569' }}>{t('sp_review_you_rated', 'You rated this trip')} <strong>{state.data.rating}/5</strong>.</p>
            {state.data.reviewText && <blockquote style={{ borderLeft: '3px solid #00d19f', padding: '4px 12px', color: '#475569', fontStyle: 'italic' }}>{state.data.reviewText}</blockquote>}
            <p style={{ fontSize: 12, color: '#94a3b8', marginTop: 16 }}>{t('sp_submitted', 'Submitted')} {new Date(state.data.submittedAt).toLocaleDateString()}.</p>
          </>
        )}

        {state.phase === 'thanks' && (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>🙌</div>
            <h2 style={{ color: '#153230', margin: '0 0 8px' }}>{t('sp_thanks_for_review', 'Thanks for the review!')}</h2>
            <p style={{ color: '#475569' }}>{t('sp_review_publish_note', 'We may publish it after a quick review.')}</p>
          </div>
        )}

        {state.phase === 'ready' && state.data && (
          <>
            <h2 style={{ color: '#153230', margin: '0 0 6px' }}>{t('sp_how_was_your_trip', 'How was your trip?')}</h2>
            <p style={{ color: '#64748b', fontSize: 14, margin: '0 0 18px' }}>
              {state.data.packageName}{state.data.courseName ? ` · ${state.data.courseName}` : ''}
            </p>
            <form onSubmit={submit}>
              <div style={{ display: 'flex', gap: 6, justifyContent: 'center', margin: '20px 0' }}>
                {[1,2,3,4,5].map(n => (
                  <button key={n} type="button" onClick={() => setRating(n)}
                    style={{ background: 'none', border: 'none', fontSize: 36, cursor: 'pointer', color: n <= rating ? '#fbbf24' : '#cbd5e1', padding: 0, lineHeight: 1 }}>★</button>
                ))}
              </div>
              <textarea value={text} onChange={e => setText(e.target.value)}
                placeholder={t('sp_review_text_placeholder', 'Anything you\'d like other golfers to know? (optional)')}
                style={{ width: '100%', padding: 10, border: '1px solid #cbd5e1', borderRadius: 6, fontSize: 14, fontFamily: 'inherit', minHeight: 100, boxSizing: 'border-box', marginBottom: 12 }} />
              <button type="submit" disabled={rating < 1 || submitting}
                style={{ width: '100%', padding: 14, background: rating < 1 ? '#cbd5e1' : '#00d19f', color: '#153230', border: 'none', borderRadius: 6, fontWeight: 700, fontSize: 16, cursor: rating < 1 ? 'not-allowed' : 'pointer' }}>
                {submitting ? t('sp_submitting', 'Submitting…') : t('sp_submit_review', 'Submit review')}
              </button>
              <div style={{ fontSize: 11, color: '#94a3b8', textAlign: 'center', marginTop: 10 }}>{t('sp_reviews_moderated_note', 'Reviews are moderated before going public.')}</div>
            </form>
          </>
        )}
      </div>
    </div>
  )
}
